import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

const Title: FC = () => {
    const { t } = useTranslation()

    return (
        <Typography.Heading variant="h4">
            {t('common.insertNoteFormContent.note')}
        </Typography.Heading>
    )
}

export default Title
